/**
 * @author      calvin@zumper.com (Calvin Yau)
 * @copyright   Copyright (c) 2019, Zumper
 * @description modals constants
 */

export const OPEN_MODAL = '@@nzr/modals/OPEN_MODAL'
export const CLOSE_MODAL = '@@nzr/modals/CLOSE_MODAL'
